import { ErrorCode } from '@kreart/shared';
import { makeErrorKeyResolver } from '@/lib/form/errorMessages';

export const errorKeyFor = makeErrorKeyResolver({
  [ErrorCode.PROJECT_ITEMS_NOT_FOUND]: 'projectItems.drawers.errors.notFound',
  [ErrorCode.PROJECT_ITEMS_PROJECT_TERMINAL]: 'projectItems.drawers.errors.projectTerminal',
  [ErrorCode.NOT_FOUND]: 'projectItems.drawers.errors.notFound',
});
